
import { NativeCurrency, Token } from '@monadex/sdk'
import { useCurrencyBalance } from '@/state/wallet/hooks'
import { formatTokenAmount, useWalletData } from '@/utils'
import CurrencySelect from '@/components/CurrencySelect'
import NumericalInput from '@/components/NumericalInput'
import useUSDCPrice from '@/utils/useUsdcPrice'
import { Wallet01Icon } from '@/utils/icons'
interface CurrencyInputProps {
  title?: string
  handleCurrencySelect: (currency: NativeCurrency | Token) => void
  currency: Token | NativeCurrency | undefined
  otherCurrency?: Token | NativeCurrency | undefined
  amount: string
  setAmount: (value: string) => void
  onMax?: () => void
  onHalf?: () => void
  showHalfButton?: boolean
  showMaxButton?: boolean
  showPrice?: boolean
  bgClass?: string
  color?: string
  id?: string
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  handleCurrencySelect,
  currency,
  otherCurrency,
  amount,
  setAmount,
  onMax,
  onHalf,
  showMaxButton,
  showHalfButton,
  title,

  showPrice,
  bgClass,
  color,
  id
}) => {
  const { account } = useWalletData()
  const selectedCurrencyBalance = useCurrencyBalance(
    account ?? undefined,
    currency
  )

  const usdPriceV2 = Number(useUSDCPrice(currency)?.toSignificant() ?? 0)
  const usdPrice = usdPriceV2
  return (
    <div
      id={id}
      className='bg-darkPurple/40 rounded-md shadow-md border border-primary/15 p-2 mb-2'
    >
      <div className='flex justify-between mb-2'>
        <p className='text-textSecondary text-md font-semibold p-1'>{title ?? 'you pay'}</p>
        <div className='flex gap-4'>
          {Boolean(account) && (currency != null) && showHalfButton === true && (
            <div className='text-primary font-lg' onClick={onHalf}>
              <small>50%</small>
            </div>
          )}
          
          {Boolean(account) && (currency != null) && showMaxButton === true && (
            <div className='' onClick={onMax}>
              <small className='text-primary font-lg'>Max</small>
            </div>
          )}
        </div>
      </div>
      <div className='flex justify-between p-1 items-center'>
        <CurrencySelect
          id={id}
          currency={currency}
          otherCurrency={otherCurrency}
          handleCurrencySelect={handleCurrencySelect}
        />
        <div className='pl-2'>
          <NumericalInput
            className='w-[15vh] md:left-[15vh] outline-none whitespace-nowrap text-ellipsis overflow-hidden text-left bg-transparent md:text-3xl placeholder:text-2xl md:placeholder:text-3xl'
            value={amount}
            align='right'
            color={color}
            placeholder='0'
            onUserInput={(val: any) => {
              setAmount(val)
            }}
          />
        </div>
      </div>
      <div className='flex justify-between items-center'>
        <div className='flex items-center p-1 gap-3'>
          <small className='text-textSecondary text-normal font-regular flex items-center gap-2'>
             <Wallet01Icon className='text-white' width={18} />{`${formatTokenAmount(selectedCurrencyBalance)}`}
          </small>
        </div>

        <small className='text-textSecondary text-normal font-regular p-1'>
         ≈ ${(usdPrice * Number(amount)).toLocaleString('us')}
        </small>
      </div>
    </div>
  )
}

export default CurrencyInput
